import useTranslate from "@app/_hooks/useTranslate";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
} from "@ui/accordion";
import { Dialog, DialogTrigger } from "@ui/dialog";
import { Paragraph } from "@ui/paragraph";
import type { INCOMING_ITEM, StockStatusProps } from "../Stock.types";
import { stockStatusVariants } from "../Stock.utils";
import StockIndicator from "./StockIndicator";

export default function IncomingItem({
  status,
  config,
}: {
  status: INCOMING_ITEM;
  config: StockStatusProps;
}) {
  const t = useTranslate();
  const { type, className, stockInfo } = config;

  const {
    root: rootSlot,
    trigger: triggerSlot,
    explanation: explanationSlot,
  } = stockStatusVariants({ type });

  if (type === "pdp") {
    return (
      <Dialog>
        <Accordion type="single" collapsible>
          <AccordionItem value={type}>
            <AccordionHeader asChild>
              <div className={rootSlot()}>
                <StockIndicator status={status.code} />
                <span className="inline-block">
                  {t("onTheWayToUs")}
                  {", "}
                  {status.date &&
                    t("backInStock")?.replace("{date}", status.date)}
                </span>
                <AccordionTrigger
                  className={triggerSlot({ kind: "accordion" })}
                >
                  {t("moreInfo")}
                </AccordionTrigger>
              </div>
            </AccordionHeader>
            <AccordionContent>
              <Paragraph className={explanationSlot()}>
                {t("incomingItemExplanation")}{" "}
                {stockInfo && (
                  <DialogTrigger className={triggerSlot({ kind: "dialog" })}>
                    {t("readMore")}
                  </DialogTrigger>
                )}
              </Paragraph>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
        {stockInfo}
      </Dialog>
    );
  }

  return (
    <div className={rootSlot({ className })}>
      <StockIndicator status={status.code} />
      <span className="inline-block">{t("inStockSoon")}</span>
    </div>
  );
}
